import React from 'react';
import { Redirect } from 'expo-router';
export default function BusinessDashboardRedirect() { return <Redirect href="/app" />; }
